import React, { Component } from 'react'
import { connect } from 'react-redux'

import { change, untouch } from 'redux-form'

import yn from 'yn'

class StateProvSelectField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentStateProv: 0
    }
  }

  componentWillUnmount() {
    const { handleResetStateProv } = this.props

    this.handleStateProvSelect(0)
    handleResetStateProv()
  }

  // Update stateProv field from placeholder value
  handleStateProvSelect = (stateProvince) => {
    this.setState({
      currentStateProv: stateProvince
    })
  }

  render(){
    const {
      input,
      label,
      size,
      stateProvinceData,
      required,
      meta: { touched, error }
    } = this.props

    let selectOptions = []

    for (let stateProvince in stateProvinceData) {
      let stateProvCode = stateProvinceData[stateProvince].code

      if (yn(process.env.REACT_APP_COMPONENT_ENABLE_COUNTRY_CODE_GEO)) {
        stateProvCode = stateProvinceData[stateProvince].codeGeo
      }

      selectOptions.push(
        <option
          key={ stateProvCode }
          value={ stateProvCode }
        >
          { stateProvinceData[stateProvince].name }
        </option>
      )
    }

    return (
      <div className={touched && error ? 'u-form-col u-form-col--error u-form-col--' + size : 'u-form-col u-form-col--' + size}>
        <label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>
          { required ? '*' : null }
          { label }
        </label>
        <select
          { ...input }
          className='u-form-select'
          aria-labelledby={ input.name + 'Label' }
          onChange={ e => { this.handleStateProvSelect( e.target.value ) } }
          value={ this.state.currentStateProv }
          required={required}
          aria-required={required ? true : false}
        >
          <option value="0" disabled>State / Province</option>
          { selectOptions }
        </select>
        { touched && ((error && <p className="u-font-error" aria-live="assertive">{error}</p>)) }
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  handleResetStateProv() {
    return dispatch(
      change('guestForm', 'stateProv', null),
      untouch('guestForm', 'stateProv')
    )
  }
})

export default connect(null, mapDispatchToProps)(StateProvSelectField)




// WEBPACK FOOTER //
// ./src/components/forms/guestForm/elements/StateProvSelectField.js